module.exports = __webpack_public_path__ + "img/symbol_5.09d6c0c1.png";